import React from 'react'
import { FaFacebookF, FaInstagram } from "react-icons/fa6";
import logo from '../../websitePictures/Logo/elevenlushevents-removebg-preview.png'
import styles from './Footer.module.css'

const Footer = () => {
  return (
    <section className={styles.footCon}>
        <div className={`container py-3 px-5`}>
            <div className="row align-items-center justify-content-between">
                <div className={`col-md-6 ${styles.firstCol}`}>
                    <img src={logo} alt="Elevenlush Events" width={100} />
                    <h5>&copy; 2025, Elevenlush Events</h5>
                </div>
                <div className={`col-md-6 text-md-end pt-4 ${styles.secCol}`}>
                    <a href="https://www.facebook.com/elevenlushevents">
                        <FaFacebookF />
                    </a>
                    <a href="https://www.instagram.com/elevenlushevents__?igsh=Y2cya21tMXJsN3d2&utm_source=qr" target='_blank' rel="noreferrer">
                        <FaInstagram />
                    </a>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Footer